import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@examdojo/core/icon';
import { SchoolService } from '@examdojo/school';
import { of, switchMap } from 'rxjs';
import { BaseClassModel, ClassColor } from '../../class/class.model';
import { ClassBackgroundComponent } from '../class-background/class-background.component';

@Component({
  selector: 'dojo-class-card',
  imports: [NgClass, IconComponent, ClassBackgroundComponent],
  templateUrl: './class-card.component.html',
  styleUrl: './class-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full' },
})
export class ClassCardComponent {
  constructor(private readonly schoolService: SchoolService) {}

  readonly classData = input.required<BaseClassModel>();
  readonly schoolNameResolved = input(false);
  readonly clicked = output<BaseClassModel>();

  protected readonly isArchived = computed(() => !!this.classData().archived_at);

  protected readonly resolvedSchoolName = toSignal(
    toObservable(computed(() => ({ resolved: this.schoolNameResolved(), raw: this.classData().school_name }))).pipe(
      switchMap(({ resolved, raw }) => (resolved ? of(raw ?? '') : this.schoolService.resolveDisplayName(raw))),
    ),
    { initialValue: '' },
  );

  protected readonly backgroundColor = computed<ClassColor>(() => {
    if (this.isArchived()) {
      return 'neutral';
    }

    return this.classData().color ?? 'indigo';
  });

  protected readonly badgeColorClass = computed(() => `bg-dynamic-${this.backgroundColor()}-100`);

  protected handleClick(): void {
    this.clicked.emit(this.classData());
  }
}
